// extracted by mini-css-extract-plugin
export default {"navigation":"Reviews_navigation__2hKZa","slide":"Reviews_slide__IrM0F","image":"Reviews_image__P+Svf","name":"Reviews_name__kaBTZ","description":"Reviews_description__bBp8e"};